import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/styles";

const UseMobileMode = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("laptop"));

  return isMobile;
};

export default UseMobileMode;
